import { combineReducers } from "redux";
import theme from "./slices/themeSlice";
import auth from "./slices/authSlice";
import banner from "./slices/bannerSlice";
import category from "./slices/categorySlice";
import product from "./slices/productSlice";
import user from "./slices/userSlice";
import order from "./slices/orderSlice";
import abandonedCart from "./slices/abandonedCartSlice";
import customer from "./slices/customerSlice";
import information from "./slices/informationSlice";
import coupon from "./slices/couponSlice";
import sale from "./slices/saleSlice";
import setting from "./slices/settingSlice";
import variant from "./slices/variantSlice";
import notification from "./slices/notificationSlice";
import pos from "./slices/posSlice";
import returnsReport from "./slices/returnsReportSlice";
import returnManagement from "./slices/returnManagementSlice";
import ticket from "./slices/ticketSlice";
import marketing from "./slices/marketingSlice";

const rootReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    theme,
    auth,
    banner,
    category,
    product,
    order,
    abandonedCart,
    customer,
    sale,
    coupon,
    user,
    information,
    setting,
    variant,
    notification,
    pos,
    returnsReport,
    returnManagement,
    ticket,
    marketing,
    ...asyncReducers,
  });
  return combinedReducer(state, action);
};

export default rootReducer;
